/**
 * merlin_api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BadgeResposne { 
    context?: string | null;
    id?: string | null;
    type?: string | null;
    name?: string | null;
    description?: string | null;
    image?: string | null;
    criteria?: string | null;
    issuer?: string | null;
}

